// components/Character.jsx
import React, { useState, useCallback, useEffect, useRef } from 'react';

const Character = () => {
  // 歡迎訊息
  const welcomeMessage = "在下正是月老！點擊我可以獲得更多姻緣小提示～";
  
  // 50組月老的隨機訊息
  const messages = [
    "姻緣天註定，但也要靠自己努力經營。",
    "愛情有五種語言，你知道自己最重視哪一種嗎？",
    "有時候，牽手的溫度勝過千言萬語。",
    "真正的愛，是願意花時間陪伴對方。",
    "禮物的價值不在貴重，而在用心。",
    "一個真心的擁抱，能融化所有的隔閡。",
    "服侍對方的日常小事，是愛最踏實的表現。",
    "讚美是愛情中不可缺少的陽光。",
    "緣分到了，自然會牽起你的手。",
    "每個人都有自己獨特的愛情表達方式。",
    "愛情需要經營，就像花兒需要陽光和雨露。",
    "與其尋找完美的人，不如找個願意一起成長的伴侶。",
    "愛情不是索取，而是給予。懂得付出，才能收穫真心。",
    "一句肯定的話語，勝過千兩黃金。",
    "情人之間，細水長流的陪伴最可貴。",
    "用心準備的禮物，是有溫度的愛意。",
    "愛是行動，不只是甜言蜜語。",
    "每個人都有自己的愛情密碼，你解讀對方的了嗎？",
    "相愛容易相處難，懂得對方的愛情語言才能長久。",
    "愛情就像茶，需要時間沉澱出最醇厚的香氣。",
    "有時候最好的禮物，是你毫無保留的時間。",
    "擁抱是世界上最真實的安慰。",
    "小小的幫助，也能傳達大大的愛意。",
    "愛一個人，就是記得他喜歡的一切小事。",
    "真心的讚美，能讓對方如沐春風。",
    "緣分的紅線一旦牽起，就要好好珍惜。",
    "愛情中最珍貴的禮物是——你全心全意的陪伴。",
    "感受愛的方式各不相同，重要的是了解彼此。",
    "對的人會懂你無言的需要，這就是緣分。",
    "愛情需要溝通，但有時也需要無言的擁抱。",
    "溫柔的撫摸、堅定的擁抱，都是愛的語言。",
    "付出不一定有回報，但真心終究會被看見。",
    "愛情就像舞蹈，需要兩個人的配合與默契。",
    "送禮物不在貴重，而在於你有多了解對方。",
    "真正的愛情是無聲的，它藏在舉手投足間。",
    "一個眼神、一個微笑，也能傳達深深的愛意。",
    "愛情不是佔有，而是成全。",
    "真愛是細水長流的陪伴，不是曇花一現的熱情。",
    "愛情需要彼此尊重與理解，才能長久。",
    "有時候，一句真誠的讚美能讓愛情升溫。",
    "陪伴是長情的告白，勝過一時的山盟海誓。",
    "愛情中的小幫助，是最暖心的告白。",
    "真心相愛的人，總能在風雨中找到彼此的手。",
    "不是每段緣分都能開花結果，但每段都有它的意義。",
    "願意為你付出時間的人，是真正在乎你的。",
    "紅線一旦牽起，天長地久需要用心經營。",
    "有時候，最好的表達就是安靜地陪伴。",
    "一個人的愛情語言是什麼，往往反映了他內心最深的渴望。",
    "幸福不是找到一個完美的人，而是找到一個願意包容你不完美的人。",
    "緣分天注定，但姻緣需要自己把握。"
  ];
  
  const [currentMessage, setCurrentMessage] = useState(welcomeMessage);
  const [showMessage, setShowMessage] = useState(true);
  const [animate, setAnimate] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const timeoutRef = useRef(null);
  
  // 設置初始歡迎訊息和自動關閉計時器
  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setShowMessage(false);
        setIsFading(false);
      }, 300);
    }, 10000);
    
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  
  // 處理點擊事件
  const handleClick = useCallback((e) => {
    // 阻止事件冒泡和默認行為
    e.stopPropagation();
    e.preventDefault();
    
    // 清除任何現有的計時器
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    // 人物跳動動畫
    setAnimate(true);
    setTimeout(() => setAnimate(false), 300);
    
    // 處理訊息顯示邏輯
    if (showMessage) {
      setIsFading(true);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * messages.length);
        setCurrentMessage(messages[randomIndex]);
        setIsFading(false);
        setShowMessage(true);
        
        timeoutRef.current = setTimeout(() => {
          setIsFading(true);
          setTimeout(() => {
            setShowMessage(false);
            setIsFading(false);
          }, 300);
        }, 6000);
      }, 300);
    } else {
      const randomIndex = Math.floor(Math.random() * messages.length);
      setCurrentMessage(messages[randomIndex]);
      setShowMessage(true);
      
      timeoutRef.current = setTimeout(() => {
        setIsFading(true);
        setTimeout(() => {
          setShowMessage(false);
          setIsFading(false);
        }, 300);
      }, 6000);
    }
  }, [showMessage, messages]);
  
  return (
    <div id="fixed-character">
      {showMessage && (
        <div className={`character-bubble ${isFading ? 'bubble-fade-out' : ''}`}>
          <p>{currentMessage}</p>
        </div>
      )}
      <img 
        src="/assets/images/yuelao.png" 
        alt="月老角色" 
        className={animate ? 'character-jump' : ''} 
        onClick={handleClick}
      />
    </div>
  );
};

export default Character;